import { LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

import { TWO_LINES_HEIGHT } from './constants';

export const useRelatedCategoriesStyles = createUseStyles(
  {
    root: {
      marginBottom: Spacings.s48,
    },

    container: {
      height: TWO_LINES_HEIGHT,
      overflow: 'hidden',
    },

    containerExpanded: {
      height: 'auto',
    },

    categories: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: Spacings.s8,
      listStyleType: 'none',
    },

    header: {
      display: 'block',
      lineHeight: `${LineHeights.l32}px`,
      marginBottom: Spacings.s24,
    },

    btnContainer: {
      marginTop: Spacings.s24,
      textAlign: 'center',
      width: '100%',
    },
  },
  { name: 'related-categories' },
);

export const useCategoryStyles = createUseStyles(
  {
    root: {
      marginBottom: Spacings.s6,
    },
  },
  {
    name: 'related-category',
  },
);
